var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    transform: "translate(24.1855) scale(-1 1)",
    fill: "white",
    stroke: "#4A95ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 7.61607C6.63393 7.16964 6.85714 6.63095 6.85714 6C6.85714 5.36905 6.63393 4.83036 6.1875 4.38393C5.74107 3.9375 5.20238 3.71429 4.57143 3.71429C3.94048 3.71429 3.40179 3.9375 2.95536 4.38393C2.50893 4.83036 2.28571 5.36905 2.28571 6C2.28571 6.63095 2.50893 7.16964 2.95536 7.61607C3.40179 8.0625 3.94048 8.28571 4.57143 8.28571C5.20238 8.28571 5.74107 8.0625 6.1875 7.61607ZM9.14286 6C9.14286 6.64881 9.04464 7.18155 8.84821 7.59821L5.59821 14.5089C5.50298 14.7054 5.36012 14.8601 5.16964 14.9732C4.98512 15.0863 4.78571 15.1429 4.57143 15.1429C4.35714 15.1429 4.15476 15.0863 3.96429 14.9732C3.77976 14.8601 3.64286 14.7054 3.55357 14.5089L0.294643 7.59821C0.0982143 7.18155 0 6.64881 0 6C0 4.73809 0.446429 3.66071 1.33929 2.76786C2.23214 1.875 3.30952 1.42857 4.57143 1.42857C5.83333 1.42857 6.91071 1.875 7.80357 2.76786C8.69643 3.66071 9.14286 4.73809 9.14286 6Z",
    transform: "translate(7.18555 4)",
    fill: "#4A95ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/locationOn.10cbcc7321e30b18f57a4d70d7070f80.svg";
export { ForwardRef as ReactComponent };